import { render } from "./contentsMainView.vue?vue&type=template&id=9074925e&scoped=true"
import script from "./contentsMainView.vue?vue&type=script&lang=js"
export * from "./contentsMainView.vue?vue&type=script&lang=js"

import "./contentsMainView.vue?vue&type=style&index=0&id=9074925e&scoped=true&lang=css"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9074925e"]])

export default __exports__